<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>
        <div>
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <input v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <select v-model="filter.type" class="form-control">
                                    <option value="">All Status</option>
                                    <option value="success">Success</option>
                                    <option value="pending">Pending</option>
                                    <option value="expired">Expired</option>
                                    <option value="canceled">Cancelled</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <input
                                    v-model="filter.start_date"
                                    type="date"
                                    class="form-control">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <input
                                    v-model="filter.end_date"
                                    type="date"
                                    class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <div>
                        <small class="d-block"><strong>{{ revenueLabel }}</strong></small>
                        <h4 class="mb-0 text-success">
                            {{ Number(result.total_revenue || 0) | formatAmount }}
                        </h4>
                    </div>
                </div>
            </div>
            <b-card no-body class="col-md-12 p-1">
                <div class="row">
                    <div class="col-md-2 ml-auto">
                        <div class="form-group">
                            <select v-model="perPage" class="form-control">
                                <option :value="10">10</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="'show-all'">Show All</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-scroll-wrapper">
                            <table class="table b-table table-fixed mb-0">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Nama Toko</th>
                                        <th>Nama Cabang</th>
                                        <th>Pembelian</th>
                                        <th>Total</th>
                                        <th>Invoice</th>
                                        <th>Status</th>
                                        <th>Payment Method</th>
                                        <th>Created At</th>
                                        <th>Updated At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="10" class="text-center">
                                            <b-spinner label="Loading..." variant="primary" />
                                        </td>
                                    </tr>
                                    <template v-if="!isLoading">
                                        <tr v-for="(item, key) in result.data" :key="item.id">
                                            <td>{{ (result.from || 0) + key }}</td>
                                            <td>{{ item.merchant_name }}</td>
                                            <td>{{ item.branch_name }}</td>
                                            <td>{{ item.pembelian_type }}</td>
                                            <td>{{ Number(item.total) | formatAmount }}</td>
                                            <td>{{ item.invoice }}</td>
                                            <td v-html="formatStatus(item.status)"></td>
                                            <td v-html="formatPaymentMethod(item)"></td>
                                            <td>{{ item.created_at }}</td>
                                            <td>{{ item.updated_at }}</td>
                                        </tr>
                                    </template>
                                    <tr v-if="!isLoading && result.data.length === 0">
                                        <td colspan="10" class="text-center">
                                            Data is empty.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="row mt-1">
                                <div class="col-6 pl-2">
                                    <small>Showing {{ result.from || 0 }} to {{ result.to || 0 }} from {{ result.total || 0 }}</small>
                                </div>
                                <div class="col-6 pr-2">
                                    <pagination
                                        :data="result"
                                        :limit="4"
                                        align="right"
                                        @pagination-change-page="page => getData(page)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import { BCard, BSpinner } from 'bootstrap-vue'
    import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
    import Vue from 'vue'
    import VuejsDialog from 'vuejs-dialog'

    import 'vuejs-dialog/dist/vuejs-dialog.min.css'

    Vue.use(VuejsDialog)

    export default {
        components: {
            BCard,
            BSpinner,
        },
        title() {
            return 'List Transaction Renewals History'
        },
        watch: {
            filter: {
                handler: _.debounce(function () {
                    this.getData(1)
                }, 300),
                deep: true,
            },
            perPage() {
                this.getData(1)
            },
        },
        setup() {
            return {
                checkPermission,
                successNotification,
                errorNotification,
            }
        },
        computed: {
            revenueLabel() {
                const { start_date, end_date } = this.filter

                const formatDate = date => this.$options.filters.formatBirthDate(date)

                if (start_date && end_date) {
                    return `Revenue Xendit ${formatDate(start_date)} - ${formatDate(end_date)}:`
                }

                if (start_date) {
                    return `Revenue Xendit dari ${formatDate(start_date)}:`
                }

                if (end_date) {
                    return `Revenue Xendit sampai ${formatDate(end_date)}:`
                }

                return 'Total Xendit Revenue:'
            },
        },
        data() {
            return {
                result: {
                    data: [],
                },
                isLoading: false,
                filter: {
                    search: '',
                    type: '',
                    start_date: '',
                    end_date: '',
                },
                currentPage: 1,
                perPage: 10,
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            formatPaymentMethod(item) {
                if (!item.payment_method) return '-'

                // VA format
                if (item.payment_method.includes('_va')) {
                    const bank = item.va_bank_code || 'Unknown Bank'
                    const vaNumber = item.va_account_number || 'Unknown VA'
                    return `VA - ${bank}<br>(${vaNumber})`
                }

                // QR format
                if (item.payment_method.includes('qr') && item.qr_channel_code) {
                    return `QR - ${item.qr_channel_code}`
                }

                // Default fallback
                return item.payment_method
            },
            formatStatus(status) {
                const statusClass = {
                    canceled: 'status-pill canceled',
                    expired: 'status-pill expired',
                    success: 'status-pill success',
                    pending: 'status-pill pending',
                }[status.toLowerCase()] || 'status-pill'

                return `<span class="${statusClass}">${status}</span>`
            },
            getData(page = 1) {
                this.isLoading = true
                this.currentPage = page

                this.$http.post('/super-admin/transaction-history/renewals', {
                    page: this.currentPage,
                    per_page: this.perPage,
                    search: this.filter.search,
                    start_date: this.filter.start_date,
                    end_date: this.filter.end_date,
                    type: this.filter.type,
                }).then(response => {
                    this.result = response.data.data
                    this.isLoading = false
                }).catch(() => {
                    this.isLoading = false
                })
            },
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    .table-scroll-wrapper {
        height: calc(100vh - 600px);
        min-height: 400px;
        overflow-y: auto;
        overflow-x: auto;
    }

    .table-scroll-wrapper table {
        margin-bottom: 0;
    }

    .table-scroll-wrapper thead th {
        position: sticky;
        top: 0;
        z-index: 100;
        background-color: #f3f2f7;
        white-space: nowrap;
        text-align: center;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
    }

    .table th {
        width: 250px;
        white-space: nowrap;
        text-align: center;
        background-color: #f3f2f7;
    }

    .table td {
        vertical-align: middle;
    }

    .status-pill {
        display: inline-block;
        padding: 0.25rem 0.75rem;
        border-radius: 999px;
        color: white;
        font-weight: 500;
        text-transform: capitalize;
        font-size: 0.875rem;
    }

    .status-pill.canceled {
        background-color: #dc3545; // red
    }

    .status-pill.expired {
        background-color: #6c757d; // gray
    }

    .status-pill.success {
        background-color: #28a745; // green
    }

    .status-pill.pending {
        background-color: #ffc107; // yellow
        color: #212529;
    }
</style>
